<script lang="ts" setup>
  import QrcodeVue from 'qrcode.vue';
  import { computed } from 'vue';
  import { Logo } from '../../../shared/ui/logo';
  import { LogoText } from '../../../shared/ui/logo-text';
  import { RulesChooser, RulesGuesser, RulesOverview } from '../../../widgets/rules';

  const props = defineProps<{ gameCode: string; joinability: 'closed' | 'open' | 'unknown' }>();

  const joinUrl = computed(() => `${window.location.origin}/code/${props.gameCode}`);
</script>

<template>
  <main id="info-view">
    <div id="rules-column">
      <RulesOverview />
      <hr class="divider" />
      <RulesChooser />
      <hr class="divider" />
      <RulesGuesser />
    </div>

    <div id="qr-column">
      <div id="qr-logo">
        <Logo />
        <LogoText id="logo-text" text="Songstar" />
      </div>
      <div v-if="joinability === 'open'" id="qr-card">
        <h2>Scan to join</h2>
        <QrcodeVue :size="280" :value="joinUrl" aria-label="QR code to join the game" level="H" />
        <div class="join-url">{{ joinUrl }}</div>
      </div>
      <p v-else-if="joinability === 'closed'" id="no-game-in-progress">
        No game in progress has the code {{ gameCode }}.
      </p>
    </div>
  </main>
</template>

<style scoped>
  #info-view {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    gap: 4rem;
    height: 100dvh;
    overflow: hidden;
    padding: 3rem 4rem;
  }

  #rules-column {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2rem;
    max-width: 40rem;
  }

  .divider {
    border: none;
    border-top: 1px solid var(--color-divider);
    margin: 0;
  }

  #qr-column {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 2rem;
  }

  #qr-logo {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  #logo-text {
    font-size: var(--font-size-2xl);
  }

  #qr-card {
    align-items: center;
    border-radius: var(--radius-card);
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    outline: var(--color-primary) solid 2px;
    padding: 2rem;
  }

  h2 {
    color: var(--color-primary);
    font-weight: 900;
    letter-spacing: 0.05em;
    margin: 0;
    text-transform: uppercase;
  }

  #no-game-in-progress {
    color: var(--color-text-muted);
    margin: 0;
    max-width: 18rem;
    text-align: center;
  }

  .join-url {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    max-width: 18rem;
    text-align: center;
    word-break: break-all;
  }
</style>
